export default "__VITE_ASSET__Dc3D8qab__"